/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SaveBookingRequest } from '../../models/save-booking-request';
import { SaveBookingResult } from '../../models/save-booking-result';

export interface PostSaveBooking$Params {
  body?: SaveBookingRequest;
}

export function postSaveBooking(
  http: HttpClient,
  rootUrl: string,
  params?: PostSaveBooking$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SaveBookingResult>> {
  const rb = new RequestBuilder(rootUrl, postSaveBooking.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SaveBookingResult>;
    }),
  );
}

postSaveBooking.PATH = '/Bookings/save-booking';
